import lodash from 'lodash';

export const {
  isNil,
  cond,
  cloneDeep,
  add,
  subtract,
  isEqual,
  defaultTo,
  omit,
  isString,
  isArray,
  isEmpty,
  uniq,
  intersection,
} = lodash;

export default lodash;
